import { useApiClient } from '../client.js'

export const PAYMENTS_BASKET = '/core/v2/business_api/me/businesses/{businessId}/payments/baskets/{basketId}'

export function getPaymentsBasket ({ businessId, basketId }) {
  const apiClient = useApiClient()

  return apiClient.get({
    url: PAYMENTS_BASKET,
    urlParams: {
      businessId,
      basketId,
    },
  })
}
